import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

import { RxComponent } from 'app/core/components/common/rx.component';
import { GlobalValidators } from 'app/core/components/common/validators';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { ClassesService } from 'app/solar/common/services/classes.service';
import { ConfigService } from 'app/core/services/config.service';
import { ActionClickEvent, BulkActionClickEvent } from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import { State } from 'app/solar/classes/components/wizard/class-instructor/edit-instructor/state.module';

@Component({
  selector: 'itpx-edit-instructor',
  templateUrl: './edit-instructor.component.html',
  styleUrls: ['./edit-instructor.component.css']
})
export class EditInstructorComponent extends RxComponent {

    public state = State; 
    private instructor: any;
    
    // Outputs
    private step = new BehaviorSubject<State>(State.Email);

    @Input()
    private data: any;
    
    private class: any;

    constructor(
        private fb: FormBuilder,
        private modalService: SmartModalService,
        private service: ClassesService,
        private configService: ConfigService
    ) {
        super();
    }

    ngOnInit() {
    }

    private onInstructorEdit(data: any) {
        this.instructor = data;
        this.step.next(State.Create);
    }
    
    private onSecondStepSubmit() {
    }
}


// WEBPACK FOOTER //
// ./src/app/solar/classes/components/wizard/class-instructor/edit-instructor/edit-instructor.component.ts